import storageUtil from '@zet/utils/storage'

const useIsSsoLoggedInUser = () => {
  const isSsoLoggedInUser = Boolean(storageUtil.getObject('isSsoLoggedInUser'))

  return { isSsoLoggedInUser }
}

export { useIsSsoLoggedInUser }
